import GraphQLApi from './GraphQLApi';
import * as Queries from './gql/PublicQueries';
import * as Mutations from './gql/PublicMutations';
import { Upload } from 'element-ui';
import ApiUtils from './util/ApiUtils';


export class PublicApi {
  private gql: GraphQLApi;

  constructor(url: string) {
    this.gql = new GraphQLApi(url);
  }


  // ****************************************
  // QUERIES
  // ****************************************
  public getEvent(id: string, draftOnly: boolean = false) {
    return this.gql.query(Queries.EVENT, { ...this.uuidOrSlug(id), draftOnly });
  }

  public getSponsors(id: string, draftOnly: boolean = false) {
      return this.gql.query(Queries.EVENT_SPONSORS, {...this.uuidOrSlug(id), draftOnly});
  }

  public getTicketDefinitions(id: string) {
    return this.gql.query(Queries.TICKET_DEFINITIONS, this.uuidOrSlug(id));
  }

  public getOrderClaims(orderId: string) {
    return this.gql.query(Queries.ORDER_CLAIMS, { id: orderId} );
  }

  // ****************************************
  // MUTATIONS
  // ****************************************
  public contactPromoter(id: string, data: any) {
    const params: any = this.uuidOrSlug(id);
    params.message = data;
    return this.gql.mutate(Mutations.CONTACT_PROMOTER, params);
  }

  public beginOrder(id: string, draftOnly: boolean = false) {
    return this.gql.mutate(Mutations.BEGIN_ORDER, {...this.uuidOrSlug(id), draftOnly});
  }

  public claimTickets(orderId: string, ticketId: string, qty: number) {
    return this.gql.mutate(Mutations.CLAIM_TICKETS, { id: orderId, ticketDefinitionId: ticketId, quantity: qty });
  }

  public updateClaim(orderId: string, claim: string, data: any) {
    return this.gql.mutate(Mutations.UPDATE_CLAIM, { id: orderId, claimId: claim, claim: data });
  }

  public updateAllClaims(orderId: string, data: any) {
    return this.gql.mutate(Mutations.UPDATE_ALL_CLAIMS, { id: orderId, claim: data });
  }

  public releaseClaims(orderId: string, data: any) {
    return this.gql.mutate(Mutations.RELEASE_CLAIMS, { id: orderId, claimIds: data });
  }

  public completeOrder(orderId: string, data: any) {
    return this.gql.mutate(Mutations.COMPLETE_ORDER, { id: orderId, token: data.token, paymentMethodId: data.paymentMethodId});
  }

  public applyPromoCode(orderId: string, paymentCode: string) {
    return this.gql.mutate(Mutations.APPLY_PROMO_CODE, { id: orderId, code: paymentCode });
  }

  public updateOrder(orderId: string, data: any) {
    return this.gql.mutate(Mutations.UPDATE_ORDER, { id: orderId, order: data });
  }

  private uuidOrSlug(val: string) {
    return ApiUtils.isUUID(val) ? {id: val} : {slug: val};
  }
}

